export const LED_BASE_ROUTE = `/lighting-retrofit`;
export const LED_PROJECT_INTRO_ROUTE = `${LED_BASE_ROUTE}/project-intro`;
export const LED_BUILDING_INFO_ROUTE = `${LED_BASE_ROUTE}/building-info`;
export const LED_SELECT_REPLACEMENTS_ROUTE = `${LED_BASE_ROUTE}/select-replacements`;
export const LED_PROJECT_SUMMARY_ROUTE = `${LED_BASE_ROUTE}/project-summary`;
export const LED_PLACE_ORDER_ROUTE = `${LED_BASE_ROUTE}/place-order`;
